module.exports = __webpack_public_path__ + "img/horizontal_6_6_8004.42520451.png";